(async() => {
    const { Core } = await importModule('Core');
    const {
        arrEq,
        $JSON,
        cache,
        fetchHTML
    } = await importModule('Utils');


    const CN_UNAVAILABLE = '!unavailable';
    const ATTR_UNAVAILABLE = 'data-unavailable';
    const ATTR_OPTION_INDEX = 'data-option-index'; 
    const ATTR_VARIANT_ID = 'variant-id'; 
    const ATTR_PICKER_TYPE = 'picker-type';
    const ATTR_SELLING_PLAN_ID = 'selling-plan-id';
    const ATTR_PRODUCT_URL = 'product-url';

    customElements.define('product-variant-selector', class extends Core {
        
        elements = {
            variantsJSON: '[data-variants-json]',
            optionsJSON: '[data-options-json]',
            displayValues: '*[data-display-value]',
            selectors: '*[data-option-selector]',
            variantIdInput: 'input[name="id"]'
        }

        subscriptions = {
            'selling-plan:change': '_onSellingPlanChange'
        }
        
        render() {
            this.options = $JSON(this.$optionsJSON);
            this.variants = $JSON(this.$variantsJSON);
            this._handleSellingPlanChange();
            this._getDefaultVariant();
            this._initCache();
            this._handleOptionChange();
            this.$variantIdInput.disabled = false;
        }

        _handleSellingPlanChange() {
            if (this.hasAttribute(ATTR_SELLING_PLAN_ID)) {
                this.sellingPlanId = this.getAttribute(ATTR_SELLING_PLAN_ID)
                this.subscribe('selling-plan:change');
            }
        }

        _handleOptionChange() {
            this._setOptionsAvailability();
            this.addEventListener('change', this._optionChangeHandler.bind(this));    
        }
        
        _getDefaultVariant() {
            this.variant = this.variants.find(({ id }) => id === +this.getAttribute(ATTR_VARIANT_ID));            
        }

        _initCache() {
            cache.set(`${this.variant.id}${this.sellingPlanId}`, this.getParentSection()?.cloneNode(true));
        }

        _setOptionsAvailability() {
            this.options
                .reduce(this._getOptionsState.bind(this), [...new Set()])
                .map(this._toggleOptionAviability.bind(this))
        }

        _optionChangeHandler(e) {
            if(!(e instanceof CustomEvent)) {
                this._updateVariantWithOption(e.target);
                this._setOptionsAvailability();
                this._publishVariantDoc();
            }
            this._updateDisplayValue(e.target);
            this.$variantIdInput.value = this.variant.id;
        }

        _onSellingPlanChange({ sellingPlanId }) {
            this.sellingPlanId = sellingPlanId;
            this._publishVariantDoc();
        }

        _updateDisplayValue(target) {
            if(!this.$displayValues.length) return;
            const match = this.$displayValues.find(item => item.getAttribute(ATTR_OPTION_INDEX) === target.getAttribute(ATTR_OPTION_INDEX));
            if(match) match.innerText = target.value;
        }

        async _publishVariantDoc() {
            this.publish('variant:change', {
                doc: cache.get(`${this.variant.id}${this.sellingPlanId}`) || await this._fetchVariantDOM(),
                variantId: this.variant.id,
                stock: this.variant.available,
                variantImagePosition: this.variant.featured_media?.position,
                sellingPlanId: this.sellingPlanId
            });

          console.log(this.variant.available);
          var klaviyoBtnEl = document.querySelector('.klaviyo-bis-trigger-button');
        
          if(klaviyoBtnEl) {
            if(this.variant.available) {
              klaviyoBtnEl.classList.add('hide');
            } else {
          klaviyoBtnEl.classList.remove('hide');       
            }
          }
        }

        async _fetchVariantDOM() {
            this.publish('variant:loading', true);
            const doc = await fetchHTML(this.requestURL);
            this.publish('variant:loading', false);
            cache.set(`${this.variant.id}${this.sellingPlanId}`, doc);
            return doc;
        }

        _updateVariantWithOption(target) {
            const index = +target.getAttribute(ATTR_OPTION_INDEX);
            this.variant = 
                this._getVariantFromValue(target.value, index) || 
                this._getFirstAvailableVariant(target.value, index);
        }

        _getVariantFromValue(setValue, i) {
            let newOptions = [...this.variant.options];
            newOptions[i] = setValue;
            return this.variants.find(({ options }) => arrEq(options, newOptions));
        }
        
        _getFirstAvailableVariant(value, index) {
            const match = this.variants.find(variant => variant.options[index] === value);
            this._selectVariantOptions(match, index);
            return match;
        }

        _selectVariantOptions(src, ignore) {
            src.options.map((value, i) => {
                if(i !== ignore) {
                    const input = this._getInputEl(value, i);
                    input.checked = true;
                    input.dispatchEvent(new CustomEvent('change', {
                        bubbles: true,
                        cancelable: true
                    }));
                }
            })
        }

        _getOptionsState(acc, option, i) {
            option.values.map(value => {
                acc.push({
                    value,
                    index: i,
                    hasVariant: !!this._getVariantFromValue(value, i)
                });
            })
            return acc;
        }

        _getInputEl(value, index) {
            return this.querySelector(`[value="${value.replace(/["\\]/g, '\\$&')}"][${ATTR_OPTION_INDEX}="${index}"]`)
        }

        _toggleOptionAviability({ value, index, hasVariant }) {
            this._getInputEl(value, index)
                .classList.toggle(CN_UNAVAILABLE, !hasVariant)
                // .toggleAttribute(ATTR_UNAVAILABLE, !hasVariant);
        }

        get requestURL() {
            const params = new URLSearchParams({ 
                'selling_plan': this.sellingPlanId || '', 
                'variant': this.variant.id,
                'section_id': this.sectionId
            });
            return `${this.productURL}?${params.toString()}`;
        }

        get productURL() {
            return this.getAttribute(ATTR_PRODUCT_URL);
        }

    });
})()